// Tipos da Gestão de Projetos (Operacional → Projetos).

export const STATUS_PROJETO = ['Planejamento', 'Em andamento', 'Pausado', 'Concluído', 'Cancelado'] as const;
export const STATUS_TAREFA = ['Pendente', 'Em andamento', 'Concluída', 'Cancelada'] as const;
export const TIPO_DEPENDENCIA = ['Fim → Início (FS)', 'Início → Início (SS)', 'Fim → Fim (FF)', 'Início → Fim (SF)'] as const;

export interface ProjetoResumo {
  id: number;
  nome: string;
  clienteId: number;
  gerenteId: number;
  status: number;
  dtInicioPlanejada: string | null;
  dtFimPlanejada: string | null;
  valorOrcado: number;
  percentualConcluido: number;
}

export interface ProjetoDetalhe extends ProjetoResumo {
  dtInicioReal: string | null;
  dtFimReal: string | null;
  observacao: string | null;
}

export interface CriarProjetoRequest {
  nome: string;
  clienteId?: number;
  gerenteId?: number;
  status?: number;
  dtInicioPlanejada?: string | null;
  dtFimPlanejada?: string | null;
  dtInicioReal?: string | null;
  dtFimReal?: string | null;
  valorOrcado?: number;
  observacao?: string | null;
}

export type AtualizarProjetoRequest = Partial<CriarProjetoRequest>;

export interface ProjetoFase {
  id: number;
  projetoId: number;
  nome: string;
  ordem: number;
  dtInicioPlanejada: string | null;
  dtFimPlanejada: string | null;
  percentualConcluido: number;
}

export interface SalvarFaseRequest {
  nome: string;
  ordem?: number;
  dtInicioPlanejada?: string | null;
  dtFimPlanejada?: string | null;
}

export interface ProjetoTarefa {
  id: number;
  projetoId: number;
  faseId: number;
  nome: string;
  responsavelId: number;
  dtInicioPlanejada: string | null;
  dtFimPlanejada: string | null;
  esforcoEstimadoHoras: number;
  esforcoRealizadoHoras: number;
  percentualConcluido: number;
  status: number;
  ordem: number;
}

export interface SalvarTarefaRequest {
  nome: string;
  faseId?: number;
  responsavelId?: number;
  dtInicioPlanejada?: string | null;
  dtFimPlanejada?: string | null;
  esforcoEstimadoHoras?: number;
  percentualConcluido?: number;
  status?: number;
  ordem?: number;
}

export interface ProjetoDependencia {
  id: number;
  projetoId: number;
  tarefaId: number;
  tarefaPredecessoraId: number;
  tipo: number;
}

export interface AdicionarDependenciaRequest {
  tarefaId: number;
  tarefaPredecessoraId: number;
  tipo?: number;
}

// ── Gantt (Fase 5) ──────────────────────────────────────────────────────────

export interface GanttTarefa {
  id: number;
  nome: string;
  faseId: number;
  dtInicio: string | null;
  dtFim: string | null;
  duracaoDias: number;
  percentualConcluido: number;
  status: number;
  critico: boolean;
  folga: number;
}

export interface Gantt {
  inicio: string | null;
  fim: string | null;
  duracaoProjetoDias: number;
  tarefas: GanttTarefa[];
  dependencias: ProjetoDependencia[];
  caminhoCritico: number[];
}

// ── Timesheet (Fase 2) ──────────────────────────────────────────────────────

export const STATUS_TIMESHEET = ['Pendente', 'Aprovado', 'Rejeitado'] as const;

export interface Timesheet {
  id: number;
  projetoId: number;
  tarefaId: number;
  funcionarioId: number;
  dtApontamento: string;
  horas: number;
  descricao: string | null;
  faturavel: boolean;
  status: number;
  motivoRejeicao: string | null;
  aprovadorId: number;
  dtAprovacao: string | null;
}

export interface SalvarTimesheetRequest {
  projetoId: number;
  funcionarioId: number;
  dtApontamento: string;
  horas: number;
  tarefaId?: number;
  descricao?: string | null;
  faturavel?: boolean;
}

export interface CustoHora {
  id: number;
  funcionarioId: number;
  custoHora: number;
}

export interface SalvarCustoHoraRequest {
  funcionarioId: number;
  custoHora: number;
}

// ── Financeiro (Fase 3) ─────────────────────────────────────────────────────

export const CATEGORIA_CUSTO = ['Mão de obra', 'Material', 'Despesa', 'Outro'] as const;

export interface ProjetoOrcamento {
  id: number;
  projetoId: number;
  categoria: number;
  valorOrcado: number;
  observacao: string | null;
}

export interface SalvarOrcamentoRequest {
  categoria: number;
  valorOrcado: number;
  observacao?: string | null;
}

export interface ProjetoDespesa {
  id: number;
  projetoId: number;
  categoria: number;
  dtLancamento: string;
  descricao: string | null;
  valor: number;
}

export interface SalvarDespesaRequest {
  categoria: number;
  dtLancamento: string;
  valor: number;
  descricao?: string | null;
}

export interface OrcadoRealizadoLinha {
  categoria: number;
  orcado: number;
  realizado: number;
  desvio: number;
  percentualExecucao: number;
}

export interface OrcadoRealizado {
  linhas: OrcadoRealizadoLinha[];
  totalOrcado: number;
  totalRealizado: number;
  totalDesvio: number;
  custoMaoDeObra: number;
  totalFaturado: number;
  saldoAFaturar: number;
  margemRealizada: number;
}

// ── Medição / Faturamento (Fase 4) ──────────────────────────────────────────

export const STATUS_MEDICAO = ['Pendente', 'Faturado', 'Cancelado'] as const;

export interface ProjetoMedicao {
  id: number;
  projetoId: number;
  descricao: string | null;
  dtMedicao: string;
  valor: number;
  status: number;
  contaReceberId: number;
  dtFaturamento: string | null;
}

export interface SalvarMedicaoRequest {
  descricao?: string | null;
  dtMedicao: string;
  valor: number;
}

export interface FaturamentoResultado {
  medicaoId: number;
  contaReceberId: number;
  mensagem: string;
}
